import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import isEmpty from "lodash/isEmpty";
import AsyncSelect from 'react-select/async';
import { activityInputPropTypes } from '../activity-input-prop-types';
import { customStyles } from '../custom-select/custom-styles';
import { CustomInput } from '../custom-select/CustomInput';
import { CustomMenuList } from '../custom-select/CustomMenuList';
import { formatOptionLabel } from '../custom-select/format-option-label';
import { useActivityInput } from '../use-activity-input';
import { useSearch } from '../../SearchForm/use-search';

export const MobileActivityInput = (props) => {
  const { intl, setMobileTrayView, mobileTrayViewValue } = useSearch();
  const placeholder = intl.formatMessage({
    id: 'shared_components.activity-input.activity-input-placeholder',
    defaultMessage: 'Enter your activity'
  });

  const {
    loadOptions,
    onChange,
    inputChange,
    handleInputFocus,
    defaultOptions,
    handleInputBlur,
    handleContainerFocus,
    isOptionError,
    isFocused,
    inputDisplay,
    urlPrefix,
    formActive,
    value
  } = useActivityInput(props);

  const [mobileInputFocused, setMobileInputFocused] = useState(false);

  const getInputColorClass = () => {
    let colorClass = '';
    if (formActive && !isFocused) {
      colorClass = 'text-gray-500';
    } else {
      const hasValue = !(isEmpty(value) || isEmpty(value.value));
      colorClass = hasValue ? ' text-gray-900' : ' text-gray-600';
    }
    return colorClass;
  };

  const handleOnChangeMobile = (...args) => {
    onChange(...args, true, () => {
      setMobileTrayView('main');
    });
  };

  const label = intl.formatMessage({
    id: 'shared_components.activity-input.activity-input-label',
    defaultMessage: 'What are you planning?'
  });

  const readonlyInput = (
    <button
      className={classNames(
        'readonly_activity_input',
        'btn-clear text-large',
        getInputColorClass()
      )}
      onClick={(e) => {
        e.preventDefault();
        setMobileTrayView('activity');
      }}
    >
      {inputDisplay || placeholder}
    </button>
  );

  return (
    <>
      {
        'main' === mobileTrayViewValue &&
          <div className="flex search_form_input_wrap_mobile responsive-padding">
            <div
              className={classNames('activity_input_wrap', 'flex column')}
              role="button"
              tabIndex="0"
              onFocus={handleContainerFocus}
            >
              <>
                <label
                  className="activity_input_label text-gray-900 text-small"
                >
                  {label}
                </label>
                {readonlyInput}
              </>
            </div>
          </div>
      }
      {
        'activity' === mobileTrayViewValue &&
          <div className="flex search_form_input_wrap_mobile responsive-padding">
            <div
              className="activity_input_wrap flex column center"
              onFocus={() => setMobileInputFocused(true)}
              onBlur={() => setMobileInputFocused(false)}
              role="button"
              tabIndex="0"
            >
              <AsyncSelect
                id="activity-input"
                instanceId="activity-input"
                controlShouldRenderValue={false}
                placeholder={placeholder}
                isClearable
                openMenuOnFocus
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
                onChange={handleOnChangeMobile}
                onInputChange={inputChange}
                inputValue={inputDisplay}
                defaultOptions={defaultOptions}
                loadOptions={loadOptions}
                formatOptionLabel={formatOptionLabel}
                noOptionsMessage={() => null}
                getOptionValue={(suggestion) => suggestion.value}
                styles={customStyles(isFocused, formActive, true)}
                components={{
                  MenuList: (props) =>
                    CustomMenuList(props, isOptionError, urlPrefix, null, handleInputBlur),
                  LoadingIndicator: () => null,
                  IndicatorsContainer: () => null,
                  Input: CustomInput
                }}
              />
            </div>
          </div>
      }
    </>
  );
};

MobileActivityInput.propTypes = activityInputPropTypes;
